import {axiosi} from '../../config/axios'
import { getAuth , signOut ,signInWithEmailAndPassword  } from "firebase/auth";
import { collection, query, where, getDocs , addDoc , doc, setDoc, getFirestore , getDoc , deleteDoc } from "firebase/firestore";
import bcrypt from "bcryptjs";
import { db } from "../../firebase";
import { convertGuestToUser } from "../../utils/guestMerge";
import { async } from '@firebase/util';

// export const signup=async(cred)=>{
//     try {
//         const res=await axiosi.post("auth/signup",cred)
//         return res.data
//     } catch (error) {
//         throw error.response.data
//     }
// }

export const signup = async (cred) => {
    try {
      // 1. check if email exists
      const q = query(collection(db, "users"), where("email", "==", cred.email));
      const snap = await getDocs(q);
  
      if (!snap.empty) {
        throw { message: "Email already exists" };
      }
  
      // 2. hash password
      const hashed = await bcrypt.hash(cred.password, 10);
  
      const meta = await getGuestMeta();

      // 3. create user in firestore
      const newUser = {
        name: cred.name,
        email: cred.email,
        password: hashed,
        isVerified: true,
        isAdmin: false,
        isGuest: false,
        createdAt: new Date(),
        ...meta
      };
  
      const docRef = await addDoc(collection(db, "users"), newUser);
  
      const userToReturn = { _id: docRef.id, ...newUser };
      
      // 4. optional → store in localStorage
      localStorage.setItem("user", JSON.stringify(userToReturn));
  
      // 🔥 Merge guest data
      await convertGuestToUser(docRef.id);

      return userToReturn;
  
    } catch (error) {
      throw error;
    }
  };

// export const login=async(cred)=>{
//     console.log("cred",cred);
//     try {
//         const res=await axiosi.post("auth/login",cred)
//         return res.data
//     } catch (error) {
//         throw error.response.data
//     }
// }

export const login = async (cred) => {
    try {
      console.log("cred", cred);
  
      // 1. Email ke basis pe user fetch karo
      const q = query(collection(db, "users"), where("email", "==", cred.email));
      const snapshot = await getDocs(q);
  
      if (snapshot.empty) {
        throw { message: "User not found" };
      }
  
      const user = snapshot.docs[0].data();
  
      // 2. Bcrypt se password compare
      const isMatch = await bcrypt.compare(cred.password, user.password);
  
      if (!isMatch) {
        throw { message: "Wrong password" };
      }
  
      // 3. Secure user return (password hide)
      const secureUser = {
        _id: snapshot.docs[0].id,
        email: user.email,
        name: user.name,
        isVerified: user.isVerified,
        isAdmin: user.isAdmin,
        isGuest: false,
        createdAt: user.createdAt,
      };
      localStorage.setItem("user", JSON.stringify(secureUser));

      // 🔥 Merge guest → logged-in user
      await convertGuestToUser(secureUser._id);

      return secureUser;
  
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

export const verifyOtp=async(cred)=>{
    try {
        const res=await axiosi.post("auth/verify-otp",cred)
        return res.data
    } catch (error) {
        throw error.response.data
    }
}
export const resendOtp=async(cred)=>{
    try {
        const res=await axiosi.post("auth/resend-otp",cred)
        return res.data
    } catch (error) {
        throw error.response.data
    }
}
export const forgotPassword=async(cred)=>{
    try {
        const res=await axiosi.post("auth/forgot-password",cred)
        return res.data
    } catch (error) {
        throw error.response.data
    }
}
export const resetPassword=async(cred)=>{
    try {
        const res=await axiosi.post("auth/reset-password",cred)
        return res.data
    } catch (error) {
        throw error.response.data
    }
}
// export const checkAuth=async(cred)=>{
//     try {
//         const res=await axiosi.get("auth/check-auths")
//         return res.data
//     } catch (error) {
//         // throw error.response.data
//         return {
//             "_id": "65b8e564ea5ce114184ccb96",
//             "email": "demo@gmail.com",
//             "isVerified": true,
//             "isAdmin": false
//         };
//     }
// }


// export const checkAuth = async (cred) => {
//     try {
//         const stored = localStorage.getItem("user");

//         if (!stored) {
//             // guest/demo user
//             return {
//                 "_id": "65b8e564ea5ce114184ccb96",
//                 "email": "demo@gmail.com",
//                 "isVerified": true,
//                 "isAdmin": false,
//                 "name":"guest"
//             };
            
            
//         }

//         const user = JSON.parse(stored);

//         return {
//             _id: user.id,      // ensure ID return hoga
//             ...user
//         };

//     } catch (error) {
        
//     }
// };

// export const checkAuth = async () => {
//   try {
//     const stored = localStorage.getItem("user");

//     if (!stored) {
//       // 1) Check if guest user already exists
//       const guestStored = localStorage.getItem("guest_user");

//       if (guestStored) {
//         return JSON.parse(guestStored); // return old guest
//       }

//       // 2) Create a new guest user
//       const guestUser = {
//         _id: "guest-" + Math.random().toString(36).substring(2, 12),
//         email: "guest@demo.com",
//         name: "Guest User",
//         isVerified: true,
//         isAdmin: false,
//         isGuest: true
//       };

//       // Save guest to localStorage
//       localStorage.setItem("guest_user", JSON.stringify(guestUser));

//       return guestUser;
//     }

//     // if logged in user
//     const user = JSON.parse(stored);

//     return {
//       _id: user.id,
//       ...user,
//       isGuest: false
//     };

//   } catch (error) {
//     console.log("Auth check error:", error);
//   }
// };


export const checkAuth = async () => {
  try {
    const stored = localStorage.getItem("user");

    if (!stored) {
      const guestStored = localStorage.getItem("guest_user");

      if (guestStored) return JSON.parse(guestStored);

      // ---- NEW GUEST CREATION ----
      const guestId = "guest-" + Math.random().toString(36).substring(2, 12);

      const meta = await getGuestMeta();

      const guestUser = {
        _id: guestId,
        email: "guest@demo.com",
        name: "Guest User",
        isVerified: true,
        isAdmin: false,
        isGuest: true,
        ...meta
      };

      // 1) Save in localStorage
      // save flag → guest existed on this session
      localStorage.setItem("was_guest", "true");
      localStorage.setItem("guest_user", JSON.stringify(guestUser));

      // 2) Save in Firebase
      const db = getFirestore();
      await setDoc(doc(db, "guests", guestId), guestUser);

      return guestUser;
    }

    // ---- REAL USER ----
    const user = JSON.parse(stored);
    return { _id: user.id, ...user, isGuest: false };

  } catch (error) {
    console.log(error);
  }
};

// export const logout=async()=>{
//     try {
//         const res=await axiosi.get("auth/logout")
//         return res.data
//     } catch (error) {
//         throw error.response.data
//     }
// }

// export const logout = async () => {
//     try {
//         localStorage.removeItem("user");


//         return { message: "Logged out successfully" };

//     } catch (error) {
//         throw { message: error.message };
//     }
// };

export const logout = async () => {
  try {
    // ---- 1. REMOVE LOGGED-IN USER ----
    localStorage.removeItem("user");

    // ---- 2. REMOVE OLD MERGED GUEST FLAGS ----
    // These ensure no wrong merging happens
    localStorage.removeItem("guest_user");
    localStorage.removeItem("was_guest");

    const meta = await getGuestMeta();

    // ---- 3. CREATE A FRESH NEW GUEST ----
    const newGuest = {
      _id: "guest-" + Math.random().toString(36).substring(2, 12),
      email: "guest@demo.com",
      name: "Guest User",
      isVerified: true,
      isAdmin: false,
      isGuest: true,
      ...meta
    };

    // We save BUT do NOT create merging flag
    localStorage.setItem("guest_user", JSON.stringify(newGuest));

    return { message: "Logged out successfully" };

  } catch (error) {
    console.log("Logout error:", error);
    throw { message: error.message };
  }
};


export const getGuestMeta = async () => {
  let ip = "unknown";

  try {
    const res = await fetch("https://api.ipify.org?format=json");
    const data = await res.json();
    ip = data.ip;
  } catch (e) {
    console.log("IP fetch error");
  }

  const device = navigator.userAgent;
  const platform = navigator.platform;

  return {
    ip,
    device,
    platform,
    createdAt: new Date(),
    lastSeen: new Date()
  };
};



// export const convertGuestToUser = async (userId) => {
//   const db = getFirestore();

//   const guestStored = localStorage.getItem("guest_user");
//   if (!guestStored) return;

//   const guest = JSON.parse(guestStored);
//   const guestId = guest._id;

//   // 1) Fetch guest cart
//   const guestCartRef = doc(db, "guestCarts", guestId);
//   const guestCartSnap = await getDoc(guestCartRef);

//   // 2) Fetch guest wishlist
//   const guestWishRef = doc(db, "guestWishlist", guestId);
//   const guestWishSnap = await getDoc(guestWishRef);

//   // 3) Fetch guest orders
//   const guestOrderRef = doc(db, "guestOrders", guestId);
//   const guestOrderSnap = await getDoc(guestOrderRef);

//   // ----- MERGE START -----

//   // Move cart
//   if (guestCartSnap.exists()) {
//     await setDoc(doc(db, "carts", userId), guestCartSnap.data());
//   }

//   // Move wishlist
//   if (guestWishSnap.exists()) {
//     await setDoc(doc(db, "wishlist", userId), guestWishSnap.data());
//   }

//   // Move orders
//   if (guestOrderSnap.exists()) {
//     await setDoc(doc(db, "orders", userId), guestOrderSnap.data());
//   }

//   // ----- DELETE GUEST DATA -----
//   await deleteDoc(doc(db, "guestCarts", guestId));
//   await deleteDoc(doc(db, "guestWishlist", guestId));
//   await deleteDoc(doc(db, "guestOrders", guestId));
//   await deleteDoc(doc(db, "guests", guestId));

//   // Remove guest from localStorage
//   localStorage.removeItem("guest_user");

//   console.log("Guest data successfully merged into user:", userId);
// };